import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import TermsOfService from "./pages/TermsOfService";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import { Homepage } from "./pages/Homepage";
import { ScrollToTop } from "./hooks/scrollToTop";
import { BookedPage } from "./pages/BookedPage";
import LanguageSwitcher from "./ui/LanguageSwitcher";
import { CookieBanner } from "./ui/CookieBanner";
import { HelmetProvider } from "react-helmet-async";
import Seo from "./components/seo";

function App() {
  return (
    <HelmetProvider>
      <Router>
        <Seo />
        <ScrollToTop />
        <Routes>
          {/* Rute pentru limba engleză */}
          <Route path="/" element={<Homepage />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/booked" element={<BookedPage />} />

          {/* Rute pentru limba germană */}
          <Route path="/de" element={<Homepage />} />
          <Route path="/terms-of-service/de" element={<TermsOfService />} />
          <Route path="/privacy-policy/de" element={<PrivacyPolicy />} />
          <Route path="/booked/de" element={<BookedPage />} />
        </Routes>
        <LanguageSwitcher />
        <CookieBanner />
      </Router>
    </HelmetProvider>
  );
}

export default App;
